/**
 * @generated SignedSource<<91ce27fe37745e0c299a381df7e99ae8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedItemDetailsAdditionalOptions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
  readonly " $fragmentType": "PdpRespSharedItemDetailsAdditionalOptions_user";
};
export type PdpRespSharedItemDetailsAdditionalOptions_user$key = {
  readonly " $data"?: PdpRespSharedItemDetailsAdditionalOptions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetailsAdditionalOptions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedItemDetailsAdditionalOptions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "bd9c2397e1b7d84f89f468282e3e3f37";

export default node;
